export default __webpack_public_path__ + "static/media/add-button.40109ec1.svg";